module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpY29uLWxvY2F0aW9uLTY0OTA5MTVjZDEzOTJhZTQ2MDgxYWY2ODU1ZTA1YTc2LnN2ZyI7"


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/icon-location.svg
// module id = 572
// module chunks = 0